<template>
  <div class="zq-footer fx-sb-c">
    <a
      v-for="item in footArr"
      :key="item.name"
      onclick="doyoo.util.openChat('g=10065874');return false;"
    >
      <div class="fx-sb-c-c">
        <img style="width: 0.67rem" :src="item.img" :alt="item.name" />
        <span>{{ item.name }}</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  props: {},
  data() {
    return {
      footArr: [
        {
          name: '预定课程',
          img: require('../assets/mindex/ydkc.png')
        },
        {
          name: '课程大纲',
          img: require('../assets/mindex/kcdg.png')
        },
        {
          name: '我要试听',
          img: require('../assets/mindex/wyst.png')
        },
        {
          name: '职业路径',
          img: require('../assets/mindex/zylj.png')
        },
        {
          name: '就业服务',
          img: require('../assets/mindex/jyfw.png')
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
}
</script>

<style scoped lang="scss">
.zq-footer {
  width: 100%;
  height: 2.16rem;
  background: #ffffff;
  padding: 0 0.4rem;
  box-sizing: border-box;
  img {
    margin-bottom: 0.27rem;
  }
}
</style>
